module.exports = __webpack_public_path__ + "gr.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/gr.svg
// module id = 580
// module chunks = 0